import React, { useState, useEffect, useContext } from "react";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  Results,
  Paging,
  WithSearch
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import { SingleLinksFacetView } from '../../shared/views/SingleLinksFacetView'
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  getConfig,
  getFacetFields
} from "../../config/config-helper";

import ResultView from "../components/ResultView";

import { Logo } from "../../shared/components/Logo";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import '../../styles/busqueda.css';
import NavigationButtons from "../../shared/components/NavigationButtons";
import { UniversityContext } from "../../routes/AppRouter";

import TagManager from 'react-gtm-module';

//const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();


export default function Investigador({ match }) {
  // estados
  const configFromEngine = getConfig();
  const [ universidad ] = useContext(UniversityContext)
  console.log(universidad.id+ ' EN HOME')
  let { hostIdentifier, searchKey, endpointBase, engineName } = configFromEngine;
  let connector = null;
  let config = null;
  
  //Marca visita de google analytics
  const nombreUniversidad = ""+universidad.id;
  TagManager.dataLayer({
    dataLayer: {
      event: 'visita',
      pagePath: 'investigador',
      university: nombreUniversidad,
    },
  });

  if( universidad.investigadores?.engineName ){
    engineName = universidad.investigadores.engineName;
    connector = new AppSearchAPIConnector({
      searchKey,
      engineName,
      hostIdentifier,
      endpointBase
    });

    config = {
      searchQuery: {
        facets: buildFacetConfigFromConfig(),
        ...buildSearchOptionsFromConfig()
      },
      autocompleteQuery: buildAutocompleteQueryConfig(),
      apiConnector: connector,
      alwaysSearchOnInitialLoad: true
    };
  }

  const [query, setQuery] = useState("");
  const [checkState, setCheckState] = useState({
    centro:false,
    investigador:true
  });
  
  //end estados
  let url=''+match.url;
  url=url.replace('/investigador','');

  const { centro } = checkState;
  let history = useHistory();

  const params = new URLSearchParams(window.location.search) ;
  let q = params.get('q') ;

  function passSearch(valor) {
    setQuery(valor);
    console.log('pass');
  }
  
  const handleSubmit = (data) => {
    console.log('%c handle sudmid dentro de investigador','background: #222; color: #bada55')
    passSearch(data)

  }

  const handleClick = ()=>{
    history.push("/"+match.params?.u+"/");
  }

  useEffect(() => {
    if(q!==null && q!=='null') {
      setQuery(q);
    }

  }, [q]);
  //if the user change the checkbox we redirect it 
  useEffect(() => {
      if(centro){
        console.log(`${url}centro/?q=${query}`)
        history.push(`${url}centro/?q=${query}`)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ centro ])

  return (
    connector ? (

    <SearchProvider config={config}  >
      <WithSearch mapContextToProps={({ wasSearched, setSearchTerm }) => ({ wasSearched, setSearchTerm })}>
        {({ wasSearched, setSearchTerm }) => {
          return (
            <div className="App">
              
              <ErrorBoundary>
                <Layout
                  header={
                    <div>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid
                            container
                            item
                            xs={8}
                            md={3}
                        >
                          <Logo />
                        </Grid>
                      </Grid>
                      <div className="searchBar">
                        <div>
                          <button 
                                className="btn-header"
                                onClick={ () => { handleClick() }}
                            >
                              volver
                          </button>

                        </div>
                        <div className="searchBar__search">
                          <SearchBox inputProps={{ placeholder: "Búsqueda de Investigadores" }} onSubmit={e => {handleSubmit(e);setSearchTerm(e); }}  autocompleteSuggestions={true}/>

                        </div>
                      </div>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <NavigationButtons state={checkState} setBusqueda={setCheckState}/>
                      </Grid>
                    </div>
                  }
                  sideContent={
                    <div>
                      {getFacetFields().map(field => (
                        <Facet 
                          key={field} 
                          field={field} 
                          label={field}
                          show={50}
                          view={ SingleLinksFacetView }
                        />
                      ))}
                    </div>
                  }
                  bodyContent={
                    <Results
                      titleField={getConfig().titleField}
                      urlField={getConfig().urlField}
                      shouldTrackClickThrough={true}
                      resultView={ResultView}
                    />
                  }
                  bodyFooter={<Paging />}
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
    )
    : null
  );
}
